import { type ComponentProps, memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const assetModalContentHeaderColumn = tailwindVariants({
  base: 'flex items-center gap-2',
  defaultVariants: {
    side: 'center',
  },
  variants: {
    side: {
      center: 'min-w-0 px-2',
      left: 'min-w-max flex-1 justify-start',
      right: 'min-w-max flex-1 justify-end',
    },
  },
});

export type AssetModalContentHeaderColumnVariants = VariantProps<typeof assetModalContentHeaderColumn>;

export type AssetModalContentHeaderColumnProps = ComponentProps<'div'> &
  Required<AssetModalContentHeaderColumnVariants>;

export const AssetModalContentHeaderColumn = memo(
  ({ className, side, ...restOfProps }: AssetModalContentHeaderColumnProps) => {
    return (
      <div
        className={assetModalContentHeaderColumn({ side, className })}
        data-side={side}
        data-testid="ASSET_MODAL_CONTENT_HEADER_COLUMN"
        {...restOfProps}
      />
    );
  },
);

AssetModalContentHeaderColumn.displayName = 'AssetModalContentHeaderColumn';
